// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

import App from "./App";

import store from "./store";
import router from "./router";
import "./registerServiceWorker";

import "@babel/polyfill";

import searchParams from "url-search-params-polyfill";

// all Cloudinary components:
import Cloudinary from "cloudinary-vue";

// LANGUAGE
// import i18n from './i18n'
// import i18n from 'vue-i18n'
import i18n from "./plugins/i18n";

import VueMq from "vue-mq";

// Plugins init

import popup from "./plugins/popup";
import overlay from "./plugins/overlay";
import Default from "./layouts/Default-Layout.vue";
Vue.use(Cloudinary, {
  configuration: { cloudName: "do4g5w4ia" },
});

Vue.use(VueMq, {
  breakpoints: {
    mobile: 600,
    tablet: 1000,
    laptop: 1400,
    desktop: Infinity,
  },
});

Vue.use(searchParams);
Vue.use(popup);
Vue.use(overlay);
Vue.prototype.$overlay({
  loading_img: "img/loader.svg",
  color: "#102b60cf",
  closable: true,
});

Vue.config.productionTip = false;

Vue.component("default-layout", Default);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  i18n,
  store,
  router,
  moment,
  components: { App },
  template: "<App/>",
});

// Shared variables
